export default "__VITE_ASSET__D$8QxVCs__"